import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyService } from '../survey.service';
import { Toast, ToastrService } from 'ngx-toastr';
import { SecurityService } from '@core/security/security.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.scss'],
})
export class FeedbackFormComponent implements OnInit {
  surveyForm: FormGroup;
  interactionId: string = '';
  type: string = 'false';
  ticketType: string = 'CIS';
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private surveyService: SurveyService,
    private toaster: ToastrService,
    private router: Router
  ) {
    this.route.queryParams.subscribe((params) => {
      this.interactionId = params?.ticketNumber;
      this.type = params?.flag;
      this.ticketType = params?.ticketType;
    });

    if (this.type == null || undefined) {
      this.router.navigate(['/surveyForm/feedback'], {
        queryParams: { flag: false },
      });
    }
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.surveyForm = this.fb.group({
      interactionId: [this.interactionId],
      feedback: ['', Validators.required],
    });
  }

  submit() {
    let data = {
      ticketNumber: this.interactionId,
      remark: this.surveyForm.value?.feedback,
      // flag:false
    };
    this.surveyService.submitFeedback(data).subscribe(
      (res) => {
        if (res) {
          this.toaster.success('We have reopen  your ticket!');
          this.router.navigate(['/feedback/submit'], {
            queryParams: { ticketId: this.interactionId },
          });
        }
      },
      (error) => {
        this.toaster.error(error);
      }
    );
  }
}
